module.exports = __webpack_public_path__ + "media/images/pic/saska/polygon_news_bigger-a69a7c5469cb2201c53dde4889d38908.png";